import * as sentry from '../../src/utils/sentry'
import * as LocalStorage from '../../../app-core/lib/util/safeLocalStorage'
import type { CatchError } from '../../../shared/lib/functional/error.no-deps'
import type { Extra, Tags } from '../../../shared/lib/ClientLog.no-deps'

export interface LS_IGetDeps {
    sentry_err: typeof sentry.err
    localStorage: {
        getItem: typeof localStorage.getItem
    }
}

function getErrorLogger(sentry_err: typeof sentry.err): LocalStorage.ErrorLogger {
    return (maybeError: CatchError, extra?: Extra, tags?: Tags) => sentry_err(maybeError, { extra, tags })
}

export function LS_get<T = never>(
    localStorageKey: string,
    deps: LS_IGetDeps = { sentry_err: sentry.err, localStorage }
): T {
    return LocalStorage.safeGetItem(localStorageKey, getErrorLogger(deps.sentry_err), deps.localStorage)
}

export interface LS_ISetDeps {
    sentry_err: typeof sentry.err
    localStorage: {
        setItem: typeof localStorage.setItem
    }
}

export function LS_set<T = never>(
    localStorageKey: string,
    value: T,
    deps: LS_ISetDeps = { sentry_err: sentry.err, localStorage }
) {
    LocalStorage.safeSetItem(localStorageKey, value, getErrorLogger(deps.sentry_err), deps.localStorage)
}

export function LS_remove(localStorageKey: string) {
    LocalStorage.safeRemoveItem(localStorageKey, getErrorLogger(sentry.err))
}
